export default __webpack_public_path__ + "static/media/Performance_Header@2x.4e0e5d68.jpg";